import { useEffect, useRef } from 'react';
import MobxWrap from '@/components/MobxWrap';
import { ProductTracker } from '@/utils/Tracker';
import useWatch from '@/utils/hooks/useWatch';
import styles from './index.module.less';
import DiffTable from './DiffTable';

const WhatsInTheBox = MobxWrap(['area', 'app', 'product'], (props) => {
  const { LANG } = props.area;
  const { InstaUserActive } = props.app;
  const ModalRef = useRef(null);

  const { visible } = useWatch({ dom: `#inthebox_entrance`, once: true });

  useEffect(() => {
    if (visible) {
      ProductTracker.inTheBoxModal({
        action: 'expose_entrance',
        productState: props.product,
      });
    }
  }, [visible]);

  const onClick = () => {
    ModalRef.current?.onShow();
  };

  return (
    <div>
      <div className={styles.contain} onClick={onClick} id='inthebox_entrance'>
        <div className={styles.title}>{LANG['productNew.whatsInTheBoxModal']}</div>
        <span className={styles.arrowRight} />
      </div>
      {InstaUserActive && <DiffTable ref={ModalRef} type='packingListPoints' {...props} />}
    </div>
  );
});

export default WhatsInTheBox;
